"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.table = exports.info = exports.error = exports.warn = exports.log = void 0;
const time_1 = require("./time");
const log = (...logs) => {
    console.log(time_1.now(), '|', ...logs);
};
exports.log = log;
const warn = (...warnings) => {
    console.warn(`=== ${time_1.now()} ===`);
    console.warn(...warnings);
    console.warn('=== === === === === === === ===');
};
exports.warn = warn;
const error = (...errors) => {
    console.error(`=== ${time_1.now()} ===`);
    console.error(...errors);
    console.error('=== === === === === === === ===');
};
exports.error = error;
const info = (...infos) => {
    console.info(`=== ${time_1.now()} ===`);
    console.info(...infos);
    console.info('=== === === === === === === ===');
};
exports.info = info;
const table = (data) => {
    console.log(`=== ${time_1.now()} ===`);
    console.table(data);
    console.log('=== === === === === === === ===');
};
exports.table = table;
//# sourceMappingURL=console.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/libs-tools/functions/console.js
// module id = 487
// module chunks = 0